var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientprovider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9043 10.6211H8.26562L7.99609 4.43359H9.17383L8.9043 10.6211ZM7.87891 12.3906C7.87891 12.1172 7.94531 11.9238 8.07812 11.8105C8.21094 11.6934 8.37695 11.6348 8.57617 11.6348C8.77148 11.6348 8.93555 11.6934 9.06836 11.8105C9.20508 11.9238 9.27344 12.1172 9.27344 12.3906C9.27344 12.6602 9.20508 12.8574 9.06836 12.9824C8.93555 13.1035 8.77148 13.1641 8.57617 13.1641C8.37695 13.1641 8.21094 13.1035 8.07812 12.9824C7.94531 12.8574 7.87891 12.6602 7.87891 12.3906Z",
    fill: "#044B7F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientprovider);
export default __webpack_public_path__ + "static/media/patientprovider.47317bec898fa70b0ceecfef1b606676.svg";
export { ForwardRef as ReactComponent };